import { render, staticRenderFns } from "./AutomationDetail.vue?vue&type=template&id=2cd2176e&scoped=true"
import script from "./AutomationDetail.vue?vue&type=script&lang=js"
export * from "./AutomationDetail.vue?vue&type=script&lang=js"
import style0 from "./AutomationDetail.vue?vue&type=style&index=0&id=2cd2176e&prod&scoped=true&lang=css"
import style1 from "./AutomationDetail.vue?vue&type=style&index=1&id=2cd2176e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd2176e",
  null
  
)

export default component.exports